import { Modal, Form, Result } from "antd";
import { ContactForm } from "./ContactForm";
import { useState } from "preact/compat";
import { sendUserData } from "../../service/ApplicationService";

export const ContactModal = ({ isOpen, close }) => {
  const [form] = Form.useForm();
  const [isSubmitted, setSubmitted] = useState(false);

  const onSubmit = (userData) => {
    try {
      sendUserData(userData.user)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Modal
      width={580}
      onCancel={() => {
        close();
        setSubmitted(false);
        form.resetFields();
      }}
      open={isOpen}
      footer={null}
    >
      {isSubmitted && (
        <Result
          status="success"
          title="Спасибо за ваш вопрос"
          subTitle="Наши менеджеры свяжутся с вами."
        />
      )}
      {!isSubmitted && <ContactForm onSubmit={onSubmit} setSubmitted={setSubmitted} form={form} />}
    </Modal>
  );
};
